import { createSelector } from 'reselect'
import { isDisabledTerminalTips } from './helper'
import { cardReadFailureErrors } from './constants'

export const selectSelectedTerminal = store => store.cartPayment.selectedTerminal

export const selectDisabledTerminalTips = (orderType) => createSelector(
	selectSelectedTerminal,
	(selectedTerminal) => {
		return isDisabledTerminalTips(selectedTerminal, orderType)
	},
)

export const selectTap2PayPaymentErrorType = store => store.cartPayment.tap2PayPaymentErrorType

export const selectCardReadFailureType = createSelector(
	selectTap2PayPaymentErrorType,
	(errorType) => {
		if (!errorType) return null
		return cardReadFailureErrors.includes(errorType) ? errorType : null
	},
)

export const selectDeviceIntegrityErrorType = createSelector(
	selectTap2PayPaymentErrorType,
	(errorType) => {
		if (!errorType) return null
		if (!cardReadFailureErrors.includes(errorType)) {
			return errorType
		}
	}
)
